import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="site-footer-brand">
          <p className="site-footer-logo">Veralyon</p>
          <p className="site-footer-tagline">{t('footer.tagline')}</p>
        </div>

        <nav className="site-footer-links" aria-label={t('footer.linksTitle')}>
          <p className="site-footer-links-title">{t('footer.linksTitle')}</p>
          <ul className="site-footer-links-list">
            <li>
              <Link to="/services" className="site-footer-link">
                {t('nav.services')}
              </Link>
            </li>
            <li>
              <Link to="/products" className="site-footer-link">
                {t('nav.products')}
              </Link>
            </li>
            <li>
              <Link to="/about" className="site-footer-link">
                {t('nav.about')}
              </Link>
            </li>
            <li>
              <Link to="/contact" className="site-footer-link">
                {t('nav.contact')}
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <div className="site-footer-bottom">
        <p className="site-footer-copy">{t('footer.copyright', { year })}</p>
      </div>
    </footer>
  );
};

export default Footer;
